"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COMBO_LINKS = exports.JURISDICCIONES = void 0;

/* eslint-disable camelcase */
var JURISDICCIONES;
exports.JURISDICCIONES = JURISDICCIONES;

(function (JURISDICCIONES) {
  JURISDICCIONES["CAPITAL_FEDERAL"] = "CAPITAL FEDERAL";
  JURISDICCIONES["LA_PLATA"] = "LA PLATA";
  JURISDICCIONES["BAHIA_BLANCA"] = "BAHIA BLANCA";
  JURISDICCIONES["PARANA"] = "PARANA";
  JURISDICCIONES["SANTA_FE"] = "SANTA FE";
  JURISDICCIONES["CORDOBA"] = "CORDOBA";
  JURISDICCIONES["MENDOZA"] = "MENDOZA";
  JURISDICCIONES["TUCUMAN"] = "TUCUMAN";
  JURISDICCIONES["RESISTENCIA"] = "RESISTENCIA";
  JURISDICCIONES["CDRO_RIVADAVIA"] = "CDRO. RIVADAVIA";
  JURISDICCIONES["SAN_MARTIN"] = "SAN MARTIN";
  JURISDICCIONES["GRAL_ROCA"] = "GRAL. ROCA";
  JURISDICCIONES["MISIONES"] = "MISIONES";
  JURISDICCIONES["MAR_DEL_PLATA"] = "MAR DEL PLATA";
  JURISDICCIONES["SALTA"] = "SALTA";
  JURISDICCIONES["CORRIENTES"] = "CORRIENTES";
})(JURISDICCIONES || (exports.JURISDICCIONES = JURISDICCIONES = {}));

var links_CABA = [{
  descripcion: 'Civil',
  link: 'https://old.pjn.gov.ar/peritos/auxiliares/bajalistado.php?f=CIVIL.pdf'
}, {
  descripcion: 'Civil y Comercial Federal',
  link: 'https://old.pjn.gov.ar/peritos/auxiliares/bajalistado.php?f=CIVIL_Y_COMERCIAL_FEDERAL.pdf'
}, {
  descripcion: 'Comercial',
  link: 'https://old.pjn.gov.ar/peritos/auxiliares/bajalistado.php?f=COMERCIAL.pdf'
}, {
  descripcion: 'Contencioso Administrativo Federal',
  link: 'https://old.pjn.gov.ar/peritos/auxiliares/bajalistado.php?f=CONTENCIOSO_ADMINISTRATIVO_FEDERAL.pdf'
}, {
  descripcion: 'Criminal y Correccional',
  link: 'https://old.pjn.gov.ar/peritos/auxiliares/bajalistado.php?f=CRIMINAL_Y_CORRECCIONAL.pdf'
}, {
  descripcion: 'Criminal y Correccional Federal',
  link: 'https://old.pjn.gov.ar/peritos/auxiliares/bajalistado.php?f=CRIMINAL_Y_CORRECCIONAL_FEDERAL.pdf'
}, {
  descripcion: 'CSJN',
  link: 'https://old.pjn.gov.ar/peritos/auxiliares/bajalistado.php?f=CSJN.pdf'
}, {
  descripcion: 'Penal Económico',
  link: 'https://old.pjn.gov.ar/peritos/auxiliares/bajalistado.php?f=PENAL_ECONOMICO.pdf'
}, {
  descripcion: 'Seguridad Social',
  link: 'https://old.pjn.gov.ar/peritos/auxiliares/bajalistado.php?f=SEGURIDAD_SOCIAL.pdf'
}, {
  descripcion: 'Trabajo',
  link: 'https://old.pjn.gov.ar/peritos/auxiliares/bajalistado.php?f=TRABAJO.pdf'
}, {
  descripcion: 'Casación Penal',
  link: 'https://old.pjn.gov.ar/peritos/auxiliares/bajalistado.php?f=CASACION_PENAL.pdf'
}];
var links_LA_PLATA = [{
  descripcion: 'La Plata',
  link: 'https://old.pjn.gov.ar/peritos/auxiliares/bajalistado.php?f=LA_PLATA.pdf'
}];
var links_BAHIA_BLANCA = [{
  descripcion: 'Bahía Blanca',
  link: 'https://old.pjn.gov.ar/peritos/auxiliares/bajalistado.php?f=BAHIA_BLANCA.pdf'
}];
var links_PARANA = [{
  descripcion: 'Paraná',
  link: 'https://old.pjn.gov.ar/peritos/auxiliares/bajalistado.php?f=PARANA.pdf'
}];
var links_SANTA_FE = [{
  descripcion: 'Santa Fe',
  link: 'https://old.pjn.gov.ar/peritos/auxiliares/bajalistado.php?f=SANTA_FE.pdf'
}];
var links_CORDOBA = [{
  descripcion: 'Córdoba',
  link: 'https://old.pjn.gov.ar/peritos/auxiliares/bajalistado.php?f=CORDOBA.pdf'
}];
var links_MENDOZA = [{
  descripcion: 'Mendoza',
  link: 'https://old.pjn.gov.ar/peritos/auxiliares/bajalistado.php?f=MENDOZA.pdf'
}];
var links_TUCUMAN = [{
  descripcion: 'Tucumán',
  link: 'https://old.pjn.gov.ar/peritos/auxiliares/bajalistado.php?f=TUCUMAN.pdf'
}];
var links_RESISTENCIA = [{
  descripcion: 'Resistencia',
  link: 'https://old.pjn.gov.ar/peritos/auxiliares/bajalistado.php?f=RESISTENCIA.pdf'
}];
var links_CDRO_RIVADAVIA = [{
  descripcion: 'Comodoro Rivadavia',
  link: 'https://old.pjn.gov.ar/peritos/auxiliares/bajalistado.php?f=COMODORO_RIVADAVIA.pdf'
}];
var links_SAN_MARTIN = [{
  descripcion: 'San Martín',
  link: 'https://old.pjn.gov.ar/peritos/auxiliares/bajalistado.php?f=SAN_MARTIN.pdf'
}];
var links_GRAL_ROCA = [{
  descripcion: 'General Roca',
  link: 'https://old.pjn.gov.ar/peritos/auxiliares/bajalistado.php?f=GENERAL_ROCA.pdf'
}];
var links_MISIONES = [{
  descripcion: 'Misiones',
  link: 'https://old.pjn.gov.ar/peritos/auxiliares/bajalistado.php?f=MISIONES.pdf'
}];
var links_MAR_DEL_PLATA = [{
  descripcion: 'Mar Del Plata',
  link: 'https://old.pjn.gov.ar/peritos/auxiliares/bajalistado.php?f=MAR_DEL_PLATA.pdf'
}];
var links_SALTA = [{
  descripcion: 'Salta',
  link: 'https://old.pjn.gov.ar/peritos/auxiliares/bajalistado.php?f=SALTA.pdf'
}];
var links_CORRIENTES = [{
  descripcion: 'Corrientes',
  link: 'https://old.pjn.gov.ar/peritos/auxiliares/bajalistado.php?f=CORRIENTES.pdf'
}];
var COMBO_LINKS = [{
  id: 'CAPITAL_FEDERAL',
  links: links_CABA
}, {
  id: 'LA_PLATA',
  links: links_LA_PLATA
}, {
  id: 'BAHIA_BLANCA',
  links: links_BAHIA_BLANCA
}, {
  id: 'PARANA',
  links: links_PARANA
}, {
  id: 'SANTA_FE',
  links: links_SANTA_FE
}, {
  id: 'CORDOBA',
  links: links_CORDOBA
}, {
  id: 'MENDOZA',
  links: links_MENDOZA
}, {
  id: 'TUCUMAN',
  links: links_TUCUMAN
}, {
  id: 'RESISTENCIA',
  links: links_RESISTENCIA
}, {
  id: 'CDRO_RIVADAVIA',
  links: links_CDRO_RIVADAVIA
}, {
  id: 'SAN_MARTIN',
  links: links_SAN_MARTIN
}, {
  id: 'GRAL_ROCA',
  links: links_GRAL_ROCA
}, {
  id: 'MISIONES',
  links: links_MISIONES
}, {
  id: 'MAR_DEL_PLATA',
  links: links_MAR_DEL_PLATA
}, {
  id: 'SALTA',
  links: links_SALTA
}, {
  id: 'CORRIENTES',
  links: links_CORRIENTES
}];
exports.COMBO_LINKS = COMBO_LINKS;